import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllCurrenciesEndpoint } from "~/modules/country/api/currency/currencyApiEndpoints.ts";
import type { Currency } from "~/modules/country/api/currency/currencyTypes.ts";

export const getAllCurrencies = (): AxiosApiResponsePromise<Currency[]> => axiosApi.get(getAllCurrenciesEndpoint);
